export const setores = {
  pergunta: "Qual setor você deseja atendimento?",
  options: [
    { id: "secretaria", label: "Secretaria" },
    { id: "financeiro", label: "Financeiro" },
    { id: "pedagogico", label: "Pedagógico" },
    { id: "comercial", label: "Comercial" },
    { id: "recuperar_senha", label: "Recuperar senha -  Portal do Aluno" },
  ]
}